<template>
  <div class="apply-step2">
    <!-- 顶部导航 -->
    <div class="top-nav">
      <!-- 左侧返回按钮 -->
      <div class="back-btn" @click="$router.go(-1)">
        <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg> -->
      </div>

      <!-- 标题 真正居中 -->
      <div class="title-wrapper">
        <h1 class="title">企业信息填写</h1>
      </div>
    </div>

    <!-- 步骤条 -->
    <div class="step-bar">
      <div class="step-item done">
        <div class="step-circle">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>
        <span>身份选择</span>
      </div>
      <div class="line done"></div>
      <div class="step-item active">
        <div class="step-circle">2</div>
        <span>填写信息</span>
      </div>
      <div class="line"></div>
      <div class="step-item">
        <div class="step-circle">3</div>
        <span>支付确认</span>
      </div>
    </div>

    <!-- 表单区域 -->
    <div class="form-section">
      <h2 class="section-title">企业基本信息</h2>
      <div class="form-card">
        <!-- 企业名称 -->
        <div class="form-item">
          <label class="label">企业名称 <span class="red">*</span></label>
          <div class="input-wrap">
            <svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">
              <path d="M3 21h18"></path>
              <path d="M5 21V7l8-4v18"></path>
            </svg>
            <input v-model="formData.name" type="text" placeholder="请输入企业全称" />
          </div>
        </div>

        <!-- 统一社会信用代码 -->
        <div class="form-item">
          <label class="label">统一社会信用代码 <span class="red">*</span></label>
          <div class="input-wrap">
            <svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">
              <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
              <path d="M16 3H6a2 2 0 0 0-2 2v2h16V5a2 2 0 0 0-2-2z"></path>
            </svg>
            <input v-model="formData.comNo" type="text" maxlength="18" placeholder="请输入18位信用代码" />
          </div>
        </div>

        <!-- 营业执照 -->
        <div class="form-item">
          <label class="label">营业执照 <span class="red">*</span></label>
          
          <!-- 上传 + 预览 同一个盒子 -->
          <div class="upload-box">
            <input
              ref="uploadRef"
              class="native-file-input"
              type="file"
              accept="image/*"
              @click="resetFileInput"
              @change="handleUpload"
            />
            
            <!-- 没上传时显示：默认上传界面 -->
            <div v-if="!previewImg" class="empty-upload">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="17 8 12 3 7 8"></polyline>
                <line x1="12" y1="3" x2="12" y2="15"></line>
              </svg>
              <p class="upload-text">点击上传营业执照</p>
              <p class="upload-tip">支持jpg、png，大小不超过5MB</p>
            </div>

            <!-- 已上传：显示预览图 -->
            <div v-else class="preview-container">
              <img :src="previewImg" class="preview-img" />
              <div class="reupload-tip">点击重新上传</div>
            </div>
          </div>
        </div>

        <!-- 申请表 -->
        <div class="form-item">
          <label class="label">申请表 <span class="red">*</span></label>
          <div @click="downloadFile" class="downloadBox">下载模板</div>
          <!-- 上传 + 预览 同一个盒子 -->
          <div class="upload-box">
            <input
              ref="uploadRef2"
              class="native-file-input"
              type="file"
              accept="image/*"
              @click="resetFileInput"
              @change="handleUpload2"
            />
            
            <!-- 没上传时显示：默认上传界面 -->
            <div v-if="!previewImg2" class="empty-upload">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="17 8 12 3 7 8"></polyline>
                <line x1="12" y1="3" x2="12" y2="15"></line>
              </svg>
              <p class="upload-text">点击上传申请表扫描件</p>
              <p class="upload-tip">支持jpg、png，大小不超过5MB</p>
            </div>

            <!-- 已上传：显示预览图 -->
            <div v-else class="preview-container">
              <img :src="previewImg2" class="preview-img" />
              <div class="reupload-tip">点击重新上传</div>
            </div>
          </div>
        </div>

        <!-- 联系人姓名 -->
        <div class="form-item">
          <label class="label">联系人姓名 <span class="red">*</span></label>
          <div class="input-wrap">
            <svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
            <input v-model="formData.contact" type="text" placeholder="请输入联系人姓名" />
          </div>
        </div>

        <!-- 手机号码 -->
        <div class="form-item">
          <label class="label">手机号码 <span class="red">*</span></label>
          <div class="input-wrap">
            <svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">
              <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
              <line x1="12" y1="18" x2="12.01" y2="18"></line>
            </svg>
            <input v-model="formData.tell" type="tel" maxlength="11" placeholder="请输入手机号码" />
          </div>
        </div>

        <!-- 验证码 -->
        <!-- <div class="form-item">
          <label class="label">验证码 <span class="red">*</span></label>
          <div class="input-row">
            <div class="input-wrap">
              <svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              </svg>
              <input v-model="formData.code" type="text" placeholder="请输入验证码" />
            </div>
            <button class="code-btn" :disabled="codeCount > 0" @click="getCode">
              {{ codeCount > 0 ? `${codeCount}s` : '获取验证码' }}
            </button>
          </div>
        </div> -->

        <!-- 电子邮箱 -->
        <div class="form-item">
          <label class="label">电子邮箱</label>
          <div class="input-wrap">
            <svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
            <input v-model="formData.email" type="email" placeholder="请输入电子邮箱（选填）" />
          </div>
        </div>
      </div>
    </div>

    <!-- 企业资质信息 -->
    <div class="form-section">
      <h2 class="section-title">企业资质信息</h2>
      <div class="form-card">
        <!-- 所属地区 -->
        <div class="form-item">
          <label class="label">所属地区 <span class="red">*</span></label>
          <div class="input-wrap select-wrap" @click="openAreaDrop">
            <svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
            <span class="select-text" :class="areaInfo.name ? '' : 'placeholder'">{{ areaInfo.name || '请选择所在地区' }}</span>
            <svg class="arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </div>
        </div>

        <!-- 企业类型 -->
        <div class="form-item">
          <label class="label">企业类型 <span class="red">*</span></label>
          <div class="input-wrap select-wrap" @click="openTypeDrop">
            <svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="3" y1="9" x2="21" y2="9"></line>
              <line x1="9" y1="21" x2="9" y2="9"></line>
            </svg>
            <span class="select-text" :class="formData.type ? '' : 'placeholder'">{{ formData.businessScope || '请选择企业类型' }}</span>
            <svg class="arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </div>
        </div>

        <!-- 主营业务 -->
        <!-- <div class="form-item">
          <label class="label">主营业务 <span class="red">*</span></label>
          <div class="tag-group">
            <span 
              class="tag" 
              :class="{ active: formData.businessScope === tag }" 
              v-for="tag in businessList" 
              :key="tag"
              @click="formData.businessScope = tag"
            >
              {{ tag }}
            </span>
          </div>
        </div> -->
      </div>
    </div>

    <!-- 提交按钮 -->
    <button class="submit-btn" @click="goNext">提交信息，下一步 →</button>

    <!-- 地区下拉弹窗 -->
    <div class="drop-modal" v-if="showAreaDrop" @click="showAreaDrop = false">
      <div class="drop-box" @click.stop>
        <div class="drop-item" v-for="item in areaList" :key="item.id" @click="chooseArea(item)">
          {{ item.name }}
        </div>
      </div>
    </div>

    <!-- 企业类型下拉弹窗 -->
    <div class="drop-modal" v-if="showTypeDrop" @click="showTypeDrop = false">
      <div class="drop-box" @click.stop>
        <div class="drop-item" v-for="item in typeList" :key="item" @click="formData.businessScope = item; showTypeDrop = false">
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplyStep2',
  data() {
    return {
      areaInfo:{name:'',id:''},
      formData: {
        name: '',
        comNo: '',
        contact: '',
        tell: '',
        // code: '',
        email: '',
        address: '',
        businessScope: '',
        licenseFileId:null,
        applicationFormId:null
      },
      // codeCount: 0,
      showAreaDrop: false,
      showTypeDrop: false,
      areaList: [],
      typeList: ['影视制作', '投资机构', '剧本IP', '宣发发行','算力技术','智能应用','文旅业态','品牌商务','综合服务'],
      // businessList: ['影视制作', '剧本创作', '后期制作', '发行推广'],
      previewImg: '',
      previewImg2: ''
    }
  },
  beforeRouteEnter(to, from, next) {
    // from 就是上一页路由对象
    

    next(vm => {
      // 把来源存到组件里，mounted 就能用
      vm.fromPath = from.path
    })
  },
  mounted () {
    if(sessionStorage.getItem('userInfo')){
      let user = JSON.parse(sessionStorage.getItem('userInfo'))
      if(user.companyApplyState == 0){
        this.$router.push('/apply/wait')
        return 
      }else if(user.companyApplyState == 1){
        this.$router.push('/apply/success')
        return 
      }else if(user.companyApplyState == 2){
        this.$router.push('/apply/reject')
        return 
      }
    }
    this.getRegion('')
    if(this.fromPath == '/apply/third'){
      const stepData = this.$store.state.step1Data;
      this.areaInfo = stepData.areaInfo;
      this.formData = stepData.formData;
      this.previewImg = stepData.previewImg;
      this.previewImg2 = stepData.previewImg2;

    }
  },
  watch: {
    
  },
  methods: {
    downloadFile(){
      // 让浏览器直接处理后端返回的文件，避免二进制内容被 axios/JSON 转换破坏。
      // 这种方式也比 blob URL + download 属性更兼容手机微信。
      window.location.href = '/resource/template.xls'
    },
    chooseArea(val){
      if(val.parentId == 0){
        this.getRegion(val.id)
      }else{
        this.areaInfo = val
        this.formData.address = val.id
        this.showAreaDrop = false
      }
    },
    getRegion(id){
      this.$ajax.get('/api/region/get',{
        params:{
          parentId:id
        }
      }).then((res) => {
        if(res.data.code == 200){
          if(id){
            this.areaList = [{name:'全部地区',id:'',parentId:0},...res.data.data]
          }else{
            this.areaList = res.data.data
          }
        }
      })
    },
    resetFileInput(e) {
      // 允许用户连续选择同一张图片，也避免依赖脚本触发 file input。
      e.target.value = ''
    },
    handleUpload(e) {
      const file = e.target.files[0]
      if (!file) return

      // 限制大小 5MB
      if (file.size > 5 * 1024 * 1024) {
        this.$toast.error('图片大小不能超过5MB')
        return
      }
      let formData = new FormData()
      formData.append('file', file) // 后端一般接收 file 字段
      this.$ajax.post('/api/resourceFile/upload', formData).then((res) => {
        if(res.data.code == 200){
          this.formData.licenseFileId = res.data.data
        }
      }).catch(() => {
        this.$toast.error('图片上传失败，请稍后重试')
      })
      // 生成本地预览地址
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.previewImg = reader.result
      }
    },
    handleUpload2(e) {
      const file = e.target.files[0]
      if (!file) return

      // 限制大小 5MB
      if (file.size > 5 * 1024 * 1024) {
        this.$toast.error('图片大小不能超过5MB')
        return
      }
      let formData = new FormData()
      formData.append('file', file) // 后端一般接收 file 字段
      this.$ajax.post('/api/resourceFile/upload', formData).then((res) => {
        if(res.data.code == 200){
          this.formData.applicationFormId = res.data.data
        }
      }).catch(() => {
        this.$toast.error('图片上传失败，请稍后重试')
      })
      // 生成本地预览地址
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.previewImg2 = reader.result
      }
    },
    getCode() {
      if (this.formData.tell.length !== 11) {
        this.$toast.error('请输入正确的手机号')
        return
      }
      this.codeCount = 60
      const timer = setInterval(() => {
        this.codeCount--
        if (this.codeCount <= 0) {
          clearInterval(timer)
        }
      }, 1000)
    },
    openAreaDrop() {
      this.showAreaDrop = true
    },
    openTypeDrop() {
      this.showTypeDrop = true
    },
    goNext() {
      // 简单校验
      const required = [
        this.formData.name,
        this.formData.comNo,
        this.formData.contact,
        this.formData.tell,
        this.formData.address,
        this.formData.businessScope,
        this.formData.licenseFileId,
        this.formData.applicationFormId
      ]

      // 检查是否有空值
      if (required.some(item => item === null || item === undefined || item === '')) {
        this.$toast.error('请填写完整信息')
        return
      }
      this.$store.commit('SET_STEP1_DATA', {
        areaInfo: this.areaInfo,
        formData: this.formData,
        previewImg: this.previewImg,
        previewImg2: this.previewImg2,
      })
      // 跳转到第三步
      this.$router.push('third')
    }
  }
}
</script>

<style scoped>
.apply-step2 {
  background-color: #f8fafc;
  min-height: 100vh;
  padding-bottom: 100px;
  font-size: 12px;
}
/* 顶部导航 */
.top-nav {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 10;
  position: relative; /* 关键 */
}
.back-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 11;
}
/* 标题容器：绝对居中，不受左右影响 */
.title-wrapper {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  pointer-events: auto;
}
/* 步骤条 */
.step-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 20px;
  background: #fff;
}
.step-item {
  display: flex;
  align-items: center;
  color: #999;
  font-size: 10px;
}
.step-item.done, .step-item.active {
  color: #165DFF;
}
.step-circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #e5e7eb;
  color: #999;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  margin-right: 6px;
}
.step-item.done .step-circle {
  background: #0fb864;
  color: #fff;
}
.step-item.active .step-circle {
  background: #165DFF;
  color: #fff;
}
.step-bar .line {
  width: 25px;
  height: 2px;
  background: #e5e7eb;
  margin: 0 8px;
}
.step-bar .line.done {
  background: #0fb864;
}
/* 表单 */
.form-section {
  padding: 20px;
}
.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}
.section-title::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 18px;
  background: #165DFF;
  margin-right: 8px;
}
.form-card {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
}
.form-item {
  margin-bottom: 20px;
}
.label {
  display: block;
  color: #333;
  margin-bottom: 8px;
}
.red {
  color: #ff4d4f;
}
.input-wrap {
  display: flex;
  align-items: center;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 0 12px;
  height: 48px;
  background: #f9fafb;
}
.input-wrap .icon {
  margin-right: 8px;
  flex-shrink: 0;
}
.input-wrap input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  color: #333;
}
.input-wrap input::placeholder {
  color: #aaa;
}
.upload-box {
  border: 1px dashed #ccc;
  border-radius: 10px;
  padding: 30px 20px;
  text-align: center;
  background: #f9fafb;
}
.upload-text {
  color: #666;
  margin: 8px 0 4px;
}
.upload-tip {
  font-size: 10px;
  color: #aaa;
}
.input-row {
  display: flex;
  gap: 12px;
}
.input-row .input-wrap {
  flex: 1;
  max-width: 180px;
}
.code-btn {
  background: #165DFF;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 0 20px;
  flex-shrink: 0;
}
.code-btn:disabled {
  background: #999;
}
.select-wrap {
  justify-content: space-between;
  cursor: pointer;
}
.select-text {
  flex: 1;
  color: #333;
}
.select-text.placeholder {
  color: #aaa;
}
.arrow {
  flex-shrink: 0;
}
.tag-group {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.tag {
  padding: 10px 20px;
  background: #f5f7fa;
  color: #666;
  border-radius: 20px;
}
.tag.active {
  background: #165DFF;
  color: #fff;
}
.submit-btn {
  width: calc(100% - 40px);
  margin: 0 20px;
  background: #165DFF;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 16px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(22, 93, 255, 0.3);
}
/* 上传盒子 */
.upload-box {
  border: 1px dashed #ccc;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  background: #f9fafb;
  position: relative;
  min-height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.native-file-input {
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

/* 未上传状态 */
.empty-upload {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.upload-text {
  font-size: 13px;
  color: #666;
  margin: 8px 0 4px;
}
.upload-tip {
  font-size: 11px;
  color: #aaa;
}

/* 预览图容器 */
.preview-container {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.preview-img {
  max-width: 100%;
  max-height: 180px;
  border-radius: 6px;
  object-fit: contain;
}

/* 重新上传提示 */
.reupload-tip {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0,0,0,0.5);
  color: #fff;
  font-size: 11px;
  padding: 4px 0;
  border-radius: 0 0 6px 6px;
}
/* 下拉弹窗 */
.drop-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.3);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.drop-box {
  width: 80%;
  background: #fff;
  border-radius: 12px;
  overflow: auto;
  max-height: 400px;
}
.drop-item {
  padding: 14px 20px;
  font-size: 13px;
  color: #333;
}
.drop-item:active {
  background: #f5f7fa;
}
.downloadBox{
  padding: 10px 30px;
  border: 1px solid #999;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/menu/join/second.vue